<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row  class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
        <span style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h5">Individuelle Pausen</span>
            <!--b-form-radio-group
                style="margin-left: auto;
                        margin-top: auto;
                         margin-bottom: auto;"
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-primary"
                buttons
            ></b-form-radio-group-->
            <v-btn
                block
                tile
                color="success"
                @click="onClick(null, 'create')"
                style="height: 32px; width: 180px !important; max-width: 180px !important; min-width: 180px !important; margin-left: auto;
                    margin-top: auto;
                     margin-bottom: auto; margin-right: 12px"
            >
              <v-icon left>
                mdi-plus
              </v-icon>
              Neue Pause
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0">
          <v-data-table
              dense
              :headers="headers"
              :items="breaks"
              height="calc(100vh - 55px - 2.55rem - 4px)"
              hide-default-footer
              disable-pagination
              sort-by="name"
              item-key="id"
              fixed-header
              ref="data_table"
              no-data-text="Keine Daten vorhanden."
          >
            <template v-slot:item.name="{ item }">
              <span><b>{{item.name}}</b></span>
            </template>
            <template v-slot:item.break_combo="{ item }">
              <span>{{formateBreakTime(item.von, item.bis)}}</span>
            </template>
            <template v-slot:item.mo="{ item }">
              <v-icon
                  v-text="`mdi-${item.mo ? 'check' : 'close'}`"
                  :style="{'color': item.mo ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.di="{ item }">
              <v-icon
                  v-text="`mdi-${item.di ? 'check' : 'close'}`"
                  :style="{'color': item.di ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.mi="{ item }">
              <v-icon
                  v-text="`mdi-${item.mi ? 'check' : 'close'}`"
                  :style="{'color': item.mi ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.do="{ item }">
              <v-icon
                  v-text="`mdi-${item.do ? 'check' : 'close'}`"
                  :style="{'color': item.do ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.fr="{ item }">
              <v-icon
                  v-text="`mdi-${item.fr ? 'check' : 'close'}`"
                  :style="{'color': item.fr ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.sa="{ item }">
              <v-icon
                  v-text="`mdi-${item.sa ? 'check' : 'close'}`"
                  :style="{'color': item.sa ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.so="{ item }">
              <v-icon
                  v-text="`mdi-${item.so ? 'check' : 'close'}`"
                  :style="{'color': item.so ? 'green' : 'red'}"
              ></v-icon>
            </template>
            <template v-slot:item.mita="{ item }">
              <span>{{formatMita(item.mita, item.mita_key)}}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                  class="ma-2"
                  text
                  icon
                  color="green"
                  @click="onClick(item, 'edit')"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn
                  class="ma-2"
                  text
                  icon
                  color="red"
                  @click="onClick(item, 'delete')"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <edit-break-dialog ref="editBreakDialog" :current-break="currentBreak" :bh-structure="bhStructure" @submit="onUpsertBreak"></edit-break-dialog>
    <v-dialog
        v-model="showDeleteBreak"
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Pause löschen ?
        </v-card-title>

        <v-card-text>
          Wollen Sie diese Pause wirklich löschen ?<br>Den zugewiesenen Mitarbeitern wird diese Pause nicht mehr angezeigt.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text
              @click="showDeleteBreak = false"
          >
            Abbbrechen
          </v-btn>

          <v-btn
              color="red darken-1"
              text
              @click="onDeleteBreak"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import EditBreakDialog from "@/views/basis_data/dialogs/edit_break_dialog.vue";
import {DateTime as LuxonDateTime} from "luxon";

export default {
  name: "break_list",
  components: {
    EditBreakDialog
  },
  data () {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: true,
        },
        {
          text: 'Pausenzeit',
          value: 'break_combo',
        },
        {
          text: 'Mo',
          value: 'mo',
        },
        {
          text: 'Di',
          value: 'di',
        },
        {
          text: 'Mi',
          value: 'mi',
        },
        {
          text: 'Do',
          value: 'do',
        },
        {
          text: 'Fr',
          value: 'fr',
        },
        {
          text: 'Sa',
          value: 'sa',
        },
        {
          text: 'So',
          value: 'so',
        },
        { text: 'Gilt für', value: 'mita'},
        { text: '', value: 'actions'},
      ],
      breaks: [],
      loader: undefined,
      showDeleteBreak: false,
      currentBreak: null,
      showEditCreate: false,
      bhStructure: [],
    }
  },
  mounted () {
  },
  created() {
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/basis_data/breaks'
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    onNewBreak() {
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkDelete(response) {
      this.hideLoader();
      if (response.status === 200) {
        for (let i = 0; i < this.breaks.length; i++) {
          if (this.breaks[i].id === this.currentBreak.id) {
            this.breaks.splice(i, 1);
            break;
          }
        }
        this.currentBreak = null;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkUpsert(response) {
      this.hideLoader();
      if (response.status === 200) {
        if (this.currentBreak.id !== "") {
          for (let i = 0; i < this.breaks.length; i++) {
            if (this.breaks[i].id === this.currentBreak.id) {
              this.breaks[i] = response.body;
              this.breaks = [...this.breaks];
              break;
            }
          }
        } else {
          this.breaks.push(response.body);
        }
        this.currentBreak = null;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.breaks = response.body.breaks;
        this.bhStructure = response.body.bh_structure;
        this.computeMitas(this.bhStructure);
      } else {
        window.location = Redirect_500;
      }
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a,b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    formateBreakTime(von, bis) {
      return von.substr(0,2)+":"+von.substr(2,2)+" - "+bis.substr(0,2)+":"+bis.substr(2,2);
    },
    formatMita(mita, mitaKey) {
      if (mitaKey === 0) {
        return "Alle";
      } else if (mitaKey === 1) {
        return mita;
      } else {
        let parsed = JSON.parse(sessionStorage.getItem(mita));
        if (parsed) {
          return parsed.full_name;
        }
      }
      return mita;
    },
    onClick(item, action) {
      console.log(item);
      console.log(action);
      if (item) {
        this.currentBreak = {...item};
      } else {
        console.log("new break")
        this.currentBreak = {
          id: "",
          name: "",
          von: "0000",
          bis: "0000",
          mo: false,
          di: false,
          mi: false,
          do: false,
          fr: false,
          sa: false,
          so: false,
          mita: "",
          mita_key: 3,
        }
      }
      switch (action) {
        case 'delete':
          this.showDeleteBreak = true;
          break;
        default:
          this.$nextTick(() => {
            this.$refs.editBreakDialog.show();
          });
          break;
      }
    },
    onDeleteBreak() {
      this.showDeleteBreak = false;
      this.showLoader();
      this.$http.delete(
          Server_URL_ZK + '/zk/basis_data/breaks/'+this.currentBreak.id
      ).then(this.responseOkDelete, this.responseError)
    },
    onUpsertBreak(breakData) {
      this.currentBreak = {...breakData};
      this.showEditCreate = false;
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/basis_data/breaks', this.currentBreak
      ).then(this.responseOkUpsert, this.responseError)
    }
  }

}
</script>

<style scoped>

.theme--light.v-data-table {
  background-color: white;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

</style>

